export default __webpack_public_path__ + "images/3_1_image.jpg";